import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { getTenantAction } from "../actions";
import { get } from "lodash";

export const useFetchTenantsListData = () => {
    const reduxDataForTenants = useSelector((state) =>
        get(state, "app.tenantListAll.responseList", "")
    );
    const tenantId = useSelector((state) =>
        get(state, "app.preSignInState.tenantId", "")
    );

    const userId = useSelector((state) =>
        get(state, "app.preSignInData.userId", "")
    );
    const authToken = useSelector((state) =>
        get(state, "app.signInData.authToken", "")
    );

    const dispatch = useDispatch();

    useEffect(() => {
        const fetchAdvertisersData = async () => {
            if (!reduxDataForTenants) {
                try {
                    await dispatch(
                        getTenantAction({ tenantId, authToken, userId })
                    ).catch((err) => {
                        console.log(err);
                    });
                } catch (err) {
                    console.log(err);
                }
            }
        };

        fetchAdvertisersData();
    }, [reduxDataForTenants]);

    // const filterAdvertisers = 
    return reduxDataForTenants;
};